import {
  FormProvider,
  SubmitHandler,
  useFieldArray,
  useForm,
} from 'react-hook-form';

import Form from '../Form';

import { type MultiVoucherFormSchema, multiVoucherFormSchema } from '../schema';
import { zodResolver } from '@hookform/resolvers/zod';

import styles from './FormList.module.scss';
import { useRouter } from 'next/router';
import { useVoucherContext } from '../../context';
import CustomCard from '../../shared/custom-card/CustomCard';
import IntroCopy from './intro-copy';
import IntroHeader from './intro-copy/IntroHeader';

const FormList = () => {
  const { setState, state } = useVoucherContext();
  const methods = useForm<MultiVoucherFormSchema>({
    resolver: zodResolver(multiVoucherFormSchema),
    defaultValues: {
      vouchers: state.vouchers,
    },
  });
  const { control, handleSubmit } = methods;

  const router = useRouter();

  const vouchers = useFieldArray({
    control,
    name: 'vouchers',
  });

  const onSubmit: SubmitHandler<MultiVoucherFormSchema> = data => {
    //save form data to context and go to next step
    setState(data);
    router.push({ query: { step: 'payment' } });
  };

  return (
    <FormProvider {...methods}>
      <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
        {vouchers.fields.map((voucher, index) => {
          const isFirst = index === 0;
          const isLast = index === vouchers.fields.length - 1;
          return (
            <div className={styles.outerContainer} key={voucher.id}>
              <div className={styles.container}>
                <div className={styles.copy}>
                  {isFirst && <IntroHeader />}
                </div>
                <div className={styles.spacer} />
              </div>
              <div className={styles.container}>
                <div className={styles.copy}>
                  {isFirst && <IntroCopy />}
                  <CustomCard index={index} />
                </div>
                <div className={styles.form}>
                  <div className={styles.voucherContainer}>
                    <div>
                      <Form index={index} isLast={isLast} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </form>
    </FormProvider>
  );
};

export default FormList;
